import { CURRENT_LOCATION } from "./type";

const initialState = {
  latlng: {
    lat: "",
    lng: "",
    address: "",
  },
};

const currentLocationReducer = (state = initialState, action) => {
  const { type, lat, lng, address } = action;
  switch (type) {
    case CURRENT_LOCATION:
      return {
        latlng: {
          lat: lat,
          lng: lng,
          address: address,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default currentLocationReducer;
